import { useEffect, useState } from 'react';
import ChatbotWidget from '../../pages/Platform/Chatbot/ChatbotWidget/ChatbotWidget';

const CHATBOT_ID = '22691f44-f807-4a7e-82b9-130355c949b2';

export default function PublicLandingChatbot() {
    const [chatbotConfig, setChatbotConfig] = useState<any>(null);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response = await fetch(`/api/chatbot/public?chatbotId=${CHATBOT_ID}`);
                if (response.ok) {
                    const data = await response.json();
                    setChatbotConfig(data.config);
                }
            } catch (error) {
                console.error('Failed to fetch chatbot config:', error);
            }
        };

        fetchConfig();
    }, []);

    if (!chatbotConfig) return null;

    return (
        <>
            <style>{`
                .proactive-bubble-wrapper.platform.right {
                    right: 110px !important;
                    bottom: 25px !important;
                }
                .proactive-bubble-wrapper.platform.left {
                    left: 110px !important;
                    bottom: 25px !important;
                }
            `}</style>
            <div style={{ position: 'fixed', bottom: 0, right: 0, zIndex: 9999 }}>
                <ChatbotWidget
                    {...chatbotConfig}
                    chatbotId={CHATBOT_ID}
                    isPlatform={true}
                    hideToggleButton={false}
                    widgetPosition="right"
                />
            </div>
        </>
    );
}
